import { Component, inject } from '@angular/core';

import { AppSessionService } from 'src/app/core/services/app-session/app-session.service';
import { AuthService } from 'src/app/core/services/auth/auth.service';
import { BannerService } from 'src/app/core/services/banner/banner.service';
import { BodyService } from 'src/app/core/services/body/body.service';
import { Router } from '@angular/router';
import { Session } from 'src/app/core/models/session';
import { SidebarService } from 'src/app/core/services/sidebar/sidebar.service';
import { AppLoaderService } from 'src/app/core/services/app-loader/app-loader.service';

@Component({
  selector: 'shared-navbar',
  templateUrl: './navbar.component.html'
})
export class NavbarComponent {

  private readonly _appSessionService: AppSessionService = inject(AppSessionService);
  private readonly _bannerService: BannerService = inject(BannerService);
  private readonly _bodyService: BodyService = inject(BodyService);
  private readonly _sidebarService: SidebarService = inject(SidebarService);
  private readonly _authService: AuthService = inject(AuthService);
  private readonly _appLoaderService: AppLoaderService = inject(AppLoaderService);

  public isVisibleDropdown: boolean = false;

  public get user(): Session | undefined {
    const user = this._appSessionService.session;
    return user;
  }

  /**
   * Event handler to control sidebar.
   */
  public toggleSidebar(): void {
    this._sidebarService.toggleSidebar();
  }

  /**
   * Event handler to control dropdown.
   */
  public toggleDropdown(): void {
    this.isVisibleDropdown = !this.isVisibleDropdown;
    this.isVisibleDropdown ? this._bodyService.blockBody() : this._bodyService.unlockBody();
  }

  /**
   * Open settings banner.
   */
  public openBanner(): void {
    this._bannerService.openBanner('Settings');
  }

  /**
   * Navigate to Office.
   */
  public redirectToOffice(): void {
    window.open("https://office.com", "_blank");
  }

  /**
   * Close session.
   */
  public logout(): void {
    this._appLoaderService.startLoading('Cerrando sesión...');
    this._authService.logout();
  }
}